import { InsuranceType } from '@nemuru-eng/js-api-client/slim';

import { Text } from '@/components/shared/components/Text';

export const getInsuranceSelectOptions = (availableInsurances: InsuranceType[]) =>
  availableInsurances.map((value) => ({
    value,
    display: <Text tId={`INSURANCE_TYPE_${value}`} />,
  }));
